import React, { useEffect, useState } from 'react';
import { AppAutocomplete } from '../ui';
import { useEntrepriseLocaleSearch } from '../../hooks/useEntrepriseLocaleSearch';

const SecteursEntrepriseAutocomplete = ({
  value,
  onSelect,
  className = '',
  inputClassName = '',
  placeholder = 'Rechercher une entreprise (SIRENE)…',
  disabled = false,
}) => {
  const [inputValue, setInputValue] = useState(value ?? '');

  useEffect(() => {
    setInputValue(value ?? '');
  }, [value]);

  const { suggestions, loading } = useEntrepriseLocaleSearch(inputValue);

  const handleSelect = (entreprise) => {
    const label = entreprise.nomRaisonSociale || entreprise.nomCommercial || '';
    setInputValue(label);
    onSelect?.({
      id: entreprise.id,
      nom: label,
      siren: entreprise.siren ?? null,
      sectionActivitePrincipale: entreprise.sectionActivitePrincipale ?? null,
      sectionActiviteLabel: entreprise.sectionActiviteLabel ?? null,
    });
  };

  return (
    <AppAutocomplete
      className={`kkp-entreprise-autocomplete ${className}`.trim()}
      inputClassName={inputClassName}
      value={inputValue}
      onChange={setInputValue}
      onSelect={handleSelect}
      items={suggestions}
      loading={loading}
      disabled={disabled}
      getItemKey={(entreprise) => entreprise.id}
      renderItem={(entreprise) => (
        <>
          {entreprise.nomRaisonSociale || entreprise.nomCommercial}
          {entreprise.siret && (
            <span className="text-secondary-light ms-2 text-sm">
              SIRET {entreprise.siret}
            </span>
          )}
          {entreprise.libelleCommune && (
            <span className="text-secondary-light ms-2 text-sm">
              {entreprise.codePostal} {entreprise.libelleCommune}
            </span>
          )}
        </>
      )}
      placeholder={placeholder}
      emptyMessage="Aucune entreprise trouvée"
      loadingLabel="Recherche…"
    />
  );
};

export default SecteursEntrepriseAutocomplete;
